export default {
  labels: {
    radius: 'Raio',
  },
};
